// Guided masterclass manual builder reusing the masterclass flow
import { ManualProgramBuilder } from '../../masterclass/manual/ManualProgramBuilder';

export const GuidedManualProgramBuilder = () => {
  // hydrateFromUrl: adopt the program name + groupId from the route when
  // resuming a guided-masterclass from the dashboard (same as the masterclass
  // route). Without it the guided builder ignored the existing group's name.
  return <ManualProgramBuilder model="masterclass&mentorship" hydrateFromUrl />;
};

export default GuidedManualProgramBuilder;
